import { useEffect } from "react"
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup"
import { TextField } from "../../../../components/styledFormElements/TextField"
import { SelectInput } from "../../../../components/styledFormElements/SelectInput"
import { ToggleField } from "../../../../components/styledFormElements/ToggleField"
import { DialogWrapper } from "../../../../components/dialogWrapper"
import { useAddUser, useUpdateUser } from "../../../../hooks/user"
import { Loader } from "../../../../components/loader"
import { Button } from "../../../../components/ui/button"
import { useNotificationBar } from "../../../../context/notificationContext"
import { getErrorResponse } from "../../../../services/util"
interface ComponentProps {
    input_data: any
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    onSubmitHandler?: Function
    rolesData?: any[]
    isEditForm?: boolean
}

const schema = yup.object({
    first_name: yup.string().required("First name is required !"),
    last_name: yup.string().required("Last name is required !"),
    email: yup.string().required("Email is required !").email("Provide valid email !"),
    role_id: yup.string().required("Role is required !"),
    password:yup.string().required("password is required !")
}).required()

const editSchema = yup.object({
    first_name: yup.string().required("First name is required !"),
    last_name: yup.string().required("Last name is required !"),
    email: yup.string().required("Email is required !").email("Provide valid email !"),
    role_id: yup.string().required("Role is required !"),
}).required()

export const AddUpdateUser: React.FC<ComponentProps> = ({ input_data, isOpen, setIsOpen, onSubmitHandler, rolesData = [],isEditForm }) => {
    let schemaToUse = isEditForm ? editSchema : schema
    const { register, formState: { errors, dirtyFields }, watch, reset, handleSubmit, control } = useForm({
        resolver: yupResolver(schemaToUse),
        mode: 'onTouched',
    })
    
    const notification = useNotificationBar()

    const { mutate: addUser, isLoading: isLoadingAdd } = useAddUser()
    const { mutate: updateUser, isLoading: isLoadingUpdate} = useUpdateUser()
    
    let isLoading = isLoadingAdd || isLoadingUpdate
    
    useEffect(() => {
        let data: any = { ...input_data, is_active: !! input_data?.is_active }
        reset(data)
    }, [input_data, reset])

    const onSubmit = (values: any) => {
        let data:any = values
        data.is_active = data.is_active ? 1 : 0
        data.role_id = parseInt(data.role_id)
        if (input_data?.id) {
            let updated :any = {}
            Object.keys(dirtyFields).forEach((key:any) => {
                updated[key] = data[key]
            })
            if(!Object.keys(updated).length) {
                return onSubmitHandler && onSubmitHandler(data);
            }
            updateUser({
                data:updated,
                id: input_data?.id
            },{
                onError(error: any) {
                    notification.push(getErrorResponse(error))
                },
                onSuccess(data, variables, context) {
                    notification.push({
                        title: 'Success !',
                        message: 'User details has been updated successfully !',
                        type: 'success'
                    })
                    onSubmitHandler && onSubmitHandler(data);
                },
            })
        }
        else {
            console.log(data,typeof(data));
            
            addUser({
                data
            }, {
                onError(error: any) {
                    notification.push(getErrorResponse(error))
                },
                onSuccess(data, variables, context) {
                    notification.push({
                        title: 'Success !',
                        message: 'User has been created successfully !',
                        type: 'success'
                    })
                    onSubmitHandler && onSubmitHandler(data);
                },
            })
        }
    }

    return (
        <DialogWrapper title={isEditForm ? 'Update User' : 'Create User'} isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField register={register('first_name')} errors={errors} label="First Name: "  />
                <TextField register={register('last_name')} errors={errors} label="Last Name: " placeholder="Last name:" />
                <TextField register={register('email')} errors={errors} label="Email: " placeholder="Email:" />
                {!isEditForm && <TextField register={register('password')} errors={errors} label="Password: " placeholder="Password:" />}
                <SelectInput name="role_id" control={control} options={
                    [
                        { value: '', display: 'Select -' },
                        ...rolesData.map(role=>({
                            value: role.id,
                            display: role.role_name
                        }))
                    ]
                }  label="Role:" />

                <ToggleField register={register('is_active')} label="Status: " display={watch('is_active') ? 'Active' : 'Inactive'} />
                <div className="col-span-full flex">
                    <div className="ml-auto flex gap-2 items-center">
                        <Button color="basic" disabled={isLoading} type="button" onClick={() => setIsOpen(false)}>Cancel</Button>
                        <Button color="blue" disabled={isLoading} type="submit">
                            {isLoading ? (
                                <><Loader/> Saving ...</>
                            ): 'Save' }
                        </Button>
                    </div>
                </div>
            </form>
        </DialogWrapper>
    )
}